// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/open_collapse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/close_collapse.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sector Materials List Page Styles */

.sector-materials-page {
  background: transparent;
  min-height: 100vh;
  color: #ffffff;
}

/* Sector Header */
.sector-header {
  width: 100%;
  margin-bottom: 2rem;
}

.sector-header-image {
  width: 100%;
  height: 200px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.4) 0%, rgba(59, 130, 246, 0.4) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.sector-header-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sector-header-placeholder {
  font-size: 3rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 2px;
}

/* Controls Section */
.sector-controls {
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.currency-selector {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.currency-dropdown {
  /* Using chart-btn-styled from MainChart */
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  color: #d1d5db;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.currency-dropdown:hover {
  background: rgba(75, 85, 99, 0.4);
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  color: #f3f4f6;
}

.dropdown-arrow {
  font-size: 10px;
  opacity: 0.6;
}

.currency-symbol {
  font-size: 14px;
}

/* Currency Dropdown Menu - Using export-dropdown-popup styling from MainChart */
.currency-dropdown-menu {
  position: absolute;
  top: 100%;
  margin-top: 8px;
  left: 0;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 8px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  color: #fff;
  font-family: 'NeoSans', sans-serif;
  z-index: 2000;
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
}

.currency-dropdown-menu::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

.currency-dropdown-menu:hover::-webkit-scrollbar {
  width: 4px;
}

.currency-dropdown-menu:hover::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.currency-dropdown-menu:hover::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

.currency-dropdown-menu:hover::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

.currency-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
  background: transparent;
}

.currency-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.convert-btn {
  /* Using chart-btn-styled from MainChart */
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  color: #d1d5db;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
}

.convert-btn:hover {
  background: rgba(75, 85, 99, 0.4);
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  color: #f3f4f6;
}

/* Time Range Selector */
.time-range-selector {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.time-range-btn {
  /* Using timeframe-pill styling from MainChart */
  padding: 8px 16px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 40px;
  text-align: center;
}

.time-range-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  border-color: rgba(255, 255, 255, 0.2);
}

.time-range-btn.active {
  /* Using active timeframe-pill styling from MainChart */
  background: transparent;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  color: #fff;
}

/* Material Lists */
.materials-lists {
  padding: 0 2rem 2rem;
}

.material-list-section {
  /* Using chart-card-container styling from chart-main.css */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3) !important;
  margin: 1.5rem 0;
  overflow: hidden;
}

.material-list-header {
  /* Using chart-card-header styling from chart-main.css */
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(17, 24, 39, 0.3);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px 16px 0 0;
  padding: 16px 20px;
  margin-bottom: 0;
  cursor: pointer;
  transition: border-radius 0.4s ease;
}

.material-list-header:hover {
  background: rgba(17, 24, 39, 0.4);
}

.material-list-header h3 {
  font-size: 1.15rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  letter-spacing: 0.5px;
}

.toggle-icon {
  width: 24px;
  height: 22px;
  background: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
  flex: 0 0 auto;
}

.toggle-icon:hover {
  opacity: 0.85;
}

.toggle-icon.expanded {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.material-list-content {
  padding: 1.25rem 3rem;
  background: rgba(17, 24, 39, 0.2);
}

/* Materials Table */
.materials-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: rgba(17, 24, 39, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  overflow: hidden;
}

.materials-table thead {
  background: linear-gradient(135deg, rgba(30, 20, 70, 0.5) 0%, rgba(20, 30, 80, 0.5) 100%);
}

.materials-table th {
  padding: 1rem 1.25rem;
  text-align: center;
  font-size: 0.85rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  text-transform: capitalize;
  letter-spacing: 0.3px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* First column (Name) should be left-aligned */
.materials-table th:first-child {
  text-align: left;
}

.materials-table tbody tr {
  transition: all 0.25s ease;
  background: transparent;
}

.materials-table tbody tr:hover {
  background: rgba(139, 92, 246, 0.08);
}

.material-row {
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.material-row:last-child {
  border-bottom: none;
}

.materials-table td {
  padding: 1rem 1.25rem;
  text-align: center;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
}

.materials-table td.nowrap-cell {
  white-space: nowrap;
}

/* First column (Name) should be left-aligned */
.materials-table td:first-child {
  text-align: left;
}

.material-name-cell {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.95);
}

.change-positive {
  color: #10b981;
  font-weight: 400;
}

.change-negative {
  color: #ef4444;
  font-weight: 400;
}

.empty-list {
  padding: 2rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.95rem;
  background: rgba(17, 24, 39, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .sector-controls {
    flex-direction: column;
    align-items: flex-start;
  }

  .time-range-selector {
    width: 100%;
  }

  .time-range-btn {
    flex: 1 1;
  }
}

@media (max-width: 768px) {
  .sector-controls,
  .materials-lists {
    padding: 1rem;
  }

  .sector-header-image {
    height: 150px;
  }

  .materials-table {
    font-size: 0.8rem;
  }

  .materials-table th,
  .materials-table td {
    padding: 0.75rem 0.5rem;
  }

  /* Make table scrollable on mobile */
  .material-list-content {
    overflow-x: auto;
  }

  .materials-table {
    min-width: 800px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/sector-materials.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6FAA6F;EAC7F,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,8FAA8F;EAC9F,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,+CAA+C;EAC/C,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,OAAO;EACP,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;EACZ;iDAC+C;EAC/C,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,WAAW;EACX,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,8FAA8F;EAC9F,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,+CAA+C;EAC/C,gDAAgD;EAChD,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,iBAAiB;EACjB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,uDAAuD;EACvD,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,yCAAyC;EACzC,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;AACtB;;AAEA;EACE,2DAA2D;EAC3D,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,8FAA8F;EAC9F,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yDAA2D;EAC3D,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA,oCAAoC;EACpC;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Sector Materials List Page Styles */\n\n.sector-materials-page {\n  background: transparent;\n  min-height: 100vh;\n  color: #ffffff;\n}\n\n/* Sector Header */\n.sector-header {\n  width: 100%;\n  margin-bottom: 2rem;\n}\n\n.sector-header-image {\n  width: 100%;\n  height: 200px;\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.4) 0%, rgba(59, 130, 246, 0.4) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.sector-header-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.sector-header-placeholder {\n  font-size: 3rem;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.9);\n  text-transform: uppercase;\n  letter-spacing: 2px;\n}\n\n/* Controls Section */\n.sector-controls {\n  padding: 1.5rem 2rem;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 2rem;\n  flex-wrap: wrap;\n}\n\n.currency-selector {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.currency-dropdown {\n  /* Using chart-btn-styled from MainChart */\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 30px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  color: #d1d5db;\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.currency-dropdown:hover {\n  background: rgba(75, 85, 99, 0.4);\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n  color: #f3f4f6;\n}\n\n.dropdown-arrow {\n  font-size: 10px;\n  opacity: 0.6;\n}\n\n.currency-symbol {\n  font-size: 14px;\n}\n\n/* Currency Dropdown Menu - Using export-dropdown-popup styling from MainChart */\n.currency-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  margin-top: 8px;\n  left: 0;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 8px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  color: #fff;\n  font-family: 'NeoSans', sans-serif;\n  z-index: 2000;\n  min-width: 200px;\n  max-height: 300px;\n  overflow-y: auto;\n  scrollbar-width: none; /* Firefox */\n}\n\n.currency-dropdown-menu::-webkit-scrollbar {\n  width: 0px;\n  background: transparent;\n}\n\n.currency-dropdown-menu:hover::-webkit-scrollbar {\n  width: 4px;\n}\n\n.currency-dropdown-menu:hover::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.currency-dropdown-menu:hover::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n}\n\n.currency-dropdown-menu:hover::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.currency-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  background: transparent;\n}\n\n.currency-dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.convert-btn {\n  /* Using chart-btn-styled from MainChart */\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 30px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  color: #d1d5db;\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.convert-btn:hover {\n  background: rgba(75, 85, 99, 0.4);\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n  color: #f3f4f6;\n}\n\n/* Time Range Selector */\n.time-range-selector {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.time-range-btn {\n  /* Using timeframe-pill styling from MainChart */\n  padding: 8px 16px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 40px;\n  text-align: center;\n}\n\n.time-range-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.time-range-btn.active {\n  /* Using active timeframe-pill styling from MainChart */\n  background: transparent;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  color: #fff;\n}\n\n/* Material Lists */\n.materials-lists {\n  padding: 0 2rem 2rem;\n}\n\n.material-list-section {\n  /* Using chart-card-container styling from chart-main.css */\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  margin: 1.5rem 0;\n  overflow: hidden;\n}\n\n.material-list-header {\n  /* Using chart-card-header styling from chart-main.css */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: rgba(17, 24, 39, 0.3);\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px 16px 0 0;\n  padding: 16px 20px;\n  margin-bottom: 0;\n  cursor: pointer;\n  transition: border-radius 0.4s ease;\n}\n\n.material-list-header:hover {\n  background: rgba(17, 24, 39, 0.4);\n}\n\n.material-list-header h3 {\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n  letter-spacing: 0.5px;\n}\n\n.toggle-icon {\n  width: 24px;\n  height: 22px;\n  background: transparent;\n  background-image: url(\"../assets/images/open_collapse.svg\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n  flex: 0 0 auto;\n}\n\n.toggle-icon:hover {\n  opacity: 0.85;\n}\n\n.toggle-icon.expanded {\n  background-image: url(\"../assets/images/close_collapse.svg\");\n}\n\n.material-list-content {\n  padding: 1.25rem 3rem;\n  background: rgba(17, 24, 39, 0.2);\n}\n\n/* Materials Table */\n.materials-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: rgba(17, 24, 39, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 24px;\n  overflow: hidden;\n}\n\n.materials-table thead {\n  background: linear-gradient(135deg, rgba(30, 20, 70, 0.5) 0%, rgba(20, 30, 80, 0.5) 100%);\n}\n\n.materials-table th {\n  padding: 1rem 1.25rem;\n  text-align: center;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n  text-transform: capitalize;\n  letter-spacing: 0.3px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* First column (Name) should be left-aligned */\n.materials-table th:first-child {\n  text-align: left;\n}\n\n.materials-table tbody tr {\n  transition: all 0.25s ease;\n  background: transparent;\n}\n\n.materials-table tbody tr:hover {\n  background: rgba(139, 92, 246, 0.08);\n}\n\n.material-row {\n  cursor: pointer;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.material-row:last-child {\n  border-bottom: none;\n}\n\n.materials-table td {\n  padding: 1rem 1.25rem;\n  text-align: center;\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.9);\n  font-weight: 400;\n}\n\n.materials-table td.nowrap-cell {\n  white-space: nowrap;\n}\n\n/* First column (Name) should be left-aligned */\n.materials-table td:first-child {\n  text-align: left;\n}\n\n.material-name-cell {\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.change-positive {\n  color: #10b981;\n  font-weight: 400;\n}\n\n.change-negative {\n  color: #ef4444;\n  font-weight: 400;\n}\n\n.empty-list {\n  padding: 2rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 0.95rem;\n  background: rgba(17, 24, 39, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .sector-controls {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .time-range-selector {\n    width: 100%;\n  }\n\n  .time-range-btn {\n    flex: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .sector-controls,\n  .materials-lists {\n    padding: 1rem;\n  }\n\n  .sector-header-image {\n    height: 150px;\n  }\n\n  .materials-table {\n    font-size: 0.8rem;\n  }\n\n  .materials-table th,\n  .materials-table td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  /* Make table scrollable on mobile */\n  .material-list-content {\n    overflow-x: auto;\n  }\n\n  .materials-table {\n    min-width: 800px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
